/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BidirectionalActionConfigTime
 */
export interface BidirectionalActionConfigTime {
    /**
     * 
     * @type {string}
     * @memberof BidirectionalActionConfigTime
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof BidirectionalActionConfigTime
     */
    required: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BidirectionalActionConfigTime
     */
    required_if_date_provided?: boolean;
}

/**
 * Check if a given object implements the BidirectionalActionConfigTime interface.
 */
export function instanceOfBidirectionalActionConfigTime(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "required" in value;

    return isInstance;
}

export function BidirectionalActionConfigTimeFromJSON(json: any): BidirectionalActionConfigTime {
    return BidirectionalActionConfigTimeFromJSONTyped(json, false);
}

export function BidirectionalActionConfigTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfigTime {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'required': json['required'],
        'required_if_date_provided': !exists(json, 'required_if_date_provided') ? undefined : json['required_if_date_provided'],
    };
}

export function BidirectionalActionConfigTimeToJSON(value?: BidirectionalActionConfigTime | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'required': value.required,
        'required_if_date_provided': value.required_if_date_provided,
    };
}

